import { LoadingOutlined, SearchOutlined } from "@ant-design/icons"
import { type SelectProps } from "antd"
import { type BaseOptionType } from "antd/lib/select"
import React, { useEffect, useState } from "react"

import SelectComponent from "../../../../../components/Select"
import { useAppSelector } from "../../../../../hooks/use-app-selector"
import { showErrorNotifications } from "../../../../../utils/handlers/handle-error"
import { getCalendarFilterOptions } from "../../../api/services.ts"

export const CalendarAddParticipantsSelect = React.forwardRef<
  HTMLSelectElement,
  SelectProps
>((props, ref) => {
  const [items, setItems] = useState<BaseOptionType[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  const userId = useAppSelector((state) => state?.auth?.userInfo?.id)

  const onSearchDependenciesHandler = async () => {
    try {
      setLoading(true)

      const res = await getCalendarFilterOptions()

      if (!res?.ok) throw new Error(res?.data?.details?.message)
      const managers = (res?.data?.sales_manager || []) as BaseOptionType[]
      setItems(managers?.filter((manager) => manager?.value !== userId))
    } catch (e) {
      showErrorNotifications(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void onSearchDependenciesHandler()
  }, [])

  return (
    <SelectComponent
      ref={ref}
      showSearch
      size="large"
      mode={"multiple"}
      loading={loading}
      optionLabelProp="label"
      // placeholder="Search by name, email, or role..."
      placeholder="Search by name"
      options={items}
      suffixIcon={loading ? <LoadingOutlined /> : <SearchOutlined />}
      maxTagCount={"responsive"}
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input?.toLowerCase())
      }
      {...props}
    />
  )
})

CalendarAddParticipantsSelect.displayName = "CalendarAddLeadsSelect"
